<template>
  <i class="tm-diag-other">
    <i class="-modes">
      <i v-for="mode in modes" :key="mode" v-text="mode" />
    </i>
  </i>
</template>

<script>
import { mapState } from 'vuex';
import _ from 'lodash-extended';
export default {
  name: 'tmDiagOther',

  computed: {
    ...mapState('timemachine', {
      MODE: (state) => state.MODE,
    }),

    modes() {
      const rv = [];
      _.each(this.MODE, (v, modeName) => {
        if (v) {
          rv.push(modeName);
        }
      });
      return rv;
    },
  },
};
</script>

<style lang="scss">
.tm-diag .tm-diag-other {
  position: fixed;
  bottom: 18px;
  right: var(--tm-pxAxisSidePadding);
  z-index: var(--tm-zDiagTracks);
  padding: 2px 4px;
  background-color: rgba(#fff, 0.5);
  color: #000;
  box-shadow: 0 0 4px rgba(#000, 0.2);

  .-modes {
    text-align: right;
  }
}
</style>
